import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from 'lodash';
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() { }

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data, mainData.useCosto, mainData.showFirmas !== false);
    let width = ['*', 'auto', 'auto', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', '*', 35, 35, 35];
    if (!mainData.useCosto) {
      width = ['*', 'auto', 'auto', 'auto', 'auto', 'auto', '*', 'auto', 'auto', '*', 35, 35, 35];
    }
    if (mainData.showFirmas === false) {
      width = width.slice(0, -2);
      if (mainData.useCosto) {
        // sin columnas de firma sobra espacio: mas ancho para Costo y Total
        width[9] = 70;
        width[10] = 70;
      }
    }
    let imgColumn = {
      // star-sized columns fill the remaining space
      // if there's more than one star-column, available width is divided equally

      text: "",
      width: "10%",

    }
    if (mainData.IMG) {
      imgColumn = {
        // star-sized columns fill the remaining space
        // if there's more than one star-column, available width is divided equally

        image: mainData.IMG,
        width: 50,
        //width: "10%",

      }
    }
    //let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: 'landscape',
      content: [
        //header
        {
          columns: [
            imgColumn,
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              text: [
                mainData.RS
              ],
              width: "15%",

            },
            {
              // fixed width
              width: "50%",
              alignment: "center",
              bold: true,
              text: [
                mainData.TITLE + "\n",
                "Del " + mainData.FI + " a " + mainData.FF + "\n",
              ],
            },
            {
              // % width
              width: "25%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          table: {
            widths: width,
            heights: 25,
            body: getTable,
          },
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data, useCosto, showFirmas = true) {
    let headers = [
      {
        text: "Hotel",
        border: [true, true, true, true],
        fontSize: 9,
        bold: true,
      },
      { text: "Pax", border: [true, true, true, true], fontSize: 9, bold: true },
      {
        text: "Fecha",
        border: [true, true, true, true],
        fontSize: 9,
        bold: true,
      },
      { text: "PickUp", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "TeeTime", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "DropOff", border: [true, true, true, true], fontSize: 9, bold: true },

      { text: "Cliente", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "Room", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "Lobby", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "Costo", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "Total", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "Comentarios", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "Folio", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "Firma PU", border: [true, true, true, true], fontSize: 9, bold: true },
      { text: "Firma DO", border: [true, true, true, true], fontSize: 9, bold: true },

    ]
    if (!useCosto) {
      headers = [
        {
          text: "Hotel",
          border: [true, true, true, true],
          fontSize: 9,
          bold: true,
        },
        { text: "Pax", border: [true, true, true, true], fontSize: 9, bold: true },
        {
          text: "Fecha",
          border: [true, true, true, true],
          fontSize: 9,
          bold: true,
        },
        { text: "PickUp", border: [true, true, true, true], fontSize: 9, bold: true },
        { text: "TeeTime", border: [true, true, true, true], fontSize: 9, bold: true },
        { text: "DropOff", border: [true, true, true, true], fontSize: 9, bold: true },

        { text: "Cliente", border: [true, true, true, true], fontSize: 9, bold: true },
        { text: "Room", border: [true, true, true, true], fontSize: 9, bold: true },
        { text: "Lobby", border: [true, true, true, true], fontSize: 9, bold: true },
        { text: "Comentarios", border: [true, true, true, true], fontSize: 9, bold: true },
        { text: "Folio", border: [true, true, true, true], fontSize: 9, bold: true },
        { text: "PU", border: [true, true, true, true], fontSize: 9, bold: true },
        { text: "DO", border: [true, true, true, true], fontSize: 9, bold: true },

      ]
    }
    let times = [
      headers
    ];
    let groupedData = [];
    let total = 0;
    let totalCantidad = 0
    let orderedData = _.orderBy(data, ["date_format", "time_format"], ["asc", "asc"]);

    /*let grouper = "";
    orderedData.forEach((venta,index) => {
      if (grouper != venta.CategoriaName) {
        groupedData.push({
          header: true,
          text: venta.CategoriaName,
        });
      }
      groupedData.push(venta);
      total += Number(venta.Total)
      totalCantidad += Number(venta.Vendidos)
      grouper = venta.CategoriaName;

      if(orderedData[index+1]){
        if(orderedData[index+1].CategoriaName  != venta.CategoriaName ){
          groupedData.push({
            footer: true,
            text: 'Total',
            total:total,
            totalCantidad:totalCantidad
          });
          total = 0
          totalCantidad = 0
        }
      }else{
           groupedData.push({
            footer: true,
            text: 'Total',
            total:total,
            totalCantidad:totalCantidad
          });
          total = 0
          totalCantidad = 0
      }

    });*/
    orderedData.forEach((venta) => {
      let rowToAdd = [];
      if (!venta.header & !venta.footer) {
        rowToAdd = [
          { text: venta.HotelName, border: [true, true, true, true], fontSize: 8 },
          { text: venta.Pax, border: [true, true, true, true], fontSize: 8 },
          { text: venta.Fecha, border: [true, true, true, true], fontSize: 8 },
          { text: venta.Pickup, border: [true, true, true, true], fontSize: 8 },
          { text: venta.TeeTime, border: [true, true, true, true], fontSize: 8 },
          { text: venta.DropOff, border: [true, true, true, true], fontSize: 8 },
          { text: venta.NombreCliente, border: [true, true, true, true], fontSize: 8 },
          { text: venta.Room, border: [true, true, true, true], fontSize: 8 },
          { text: venta.Lobby, border: [true, true, true, true], fontSize: 8 },
          { text: venta.Precio + " " + venta.Moneda, border: [true, true, true, true], fontSize: 8 },
          { text: venta.Total + " " + venta.Moneda, border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: venta.Confirmation, border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
        ]
        if (!useCosto) {
          rowToAdd = [
            { text: venta.HotelName, border: [true, true, true, true], fontSize: 8 },
            { text: venta.Pax, border: [true, true, true, true], fontSize: 8 },
            { text: venta.Fecha, border: [true, true, true, true], fontSize: 8 },
            { text: venta.Pickup, border: [true, true, true, true], fontSize: 8 },
            { text: venta.TeeTime, border: [true, true, true, true], fontSize: 8 },
            { text: venta.DropOff, border: [true, true, true, true], fontSize: 8 },
            { text: venta.NombreCliente, border: [true, true, true, true], fontSize: 8 },
            { text: venta.Room, border: [true, true, true, true], fontSize: 8 },
            { text: venta.Lobby, border: [true, true, true, true], fontSize: 8 },
            { text: "", border: [true, true, true, true], fontSize: 8 },
            { text: venta.Confirmation, border: [true, true, true, true], fontSize: 8 },
            { text: "", border: [true, true, true, true], fontSize: 8 },
            { text: "", border: [true, true, true, true], fontSize: 8 },
          ]
        }
        times.push(
          rowToAdd
        )
      }
    })

    for (var i = 0; i < 5; i++) {
      let row = [
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
        { text: "", border: [true, true, true, true], fontSize: 8 },
      ]

      if (!useCosto) {
        row = [
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
          { text: "", border: [true, true, true, true], fontSize: 8 },
        ]
      }


      times.push(
        row
      )
    }

    if (!showFirmas) {
      // quita las columnas PU y DO (las ultimas dos)
      times = times.map((row) => row.slice(0, -2));
    }

    return times;
  }

  static getFirmas(data, porcentaje) {
    let times = [
      [
        { text: "Mesero", border: [true, true, true, true], fontSize: 12 },
        { text: "Total", border: [true, true, true, true], fontSize: 12 },
        {
          text: "%" + porcentaje,
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Firma", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    data.forEach((venta) => {
      let rowToAdd = [];
      if (venta.tipo == "footer") {
        rowToAdd = [
          {
            text: venta.Mesero,
            border: [true, true, true, true],
            fontSize: 10,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Total),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text:
              "$" +
              pgsHelper.formatNumber((venta.Total * Number(porcentaje)) / 100),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text: " ",
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "center",
          },
        ];
        times.push(rowToAdd);
      }
    });

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      heights: 60,
      table: {
        body: times,
      },
    };

    return times;
  }
}
